module.exports = __webpack_public_path__ + "static/media/banner-3.f2fb5bd9.svg";